import type { BindResult, ReturnContext } from "@screen/Home/pages/Account/API/handlePaymentAPI";

/** 輪詢上限（毫秒）：逾時視為「驗證逾時」。 */
export const BIND_3DS_POLL_CAP_MS = 90_000;
/** 輪詢間隔（毫秒）。 */
export const BIND_3DS_POLL_INTERVAL_MS = 2_000;

export type Bind3dsOutcome = "poll" | "redirect" | "wallet" | "fail" | "timeout";

/**
 * 3DS 落地頁（§6）：依 bind-result 輪詢結果 + 已耗時，決定下一步動作。純函式，方便測試。
 *   - succeeded：return_context.type==='pay_order' → redirect（回付款頁）；否則 → wallet（卡片列表/成功頁）。
 *   - failed：fail。
 *   - expired：timeout（不論已耗時多久）。
 *   - pending：耗時 < 上限 → 續輪詢；達上限 → timeout。
 *   - result 尚未回來（null）：< 上限則 poll，否則 timeout（保底，避免請求一直失敗也不停）。
 */
export const nextBind3dsAction = (result: BindResult | null, elapsedMs: number, capMs: number = BIND_3DS_POLL_CAP_MS): Bind3dsOutcome => {
  if (!result) {
    return elapsedMs >= capMs ? "timeout" : "poll";
  }
  switch (result.status) {
    case "succeeded":
      return result.return_context?.type === "pay_order" ? "redirect" : "wallet";
    case "failed":
      return "fail";
    case "expired":
      return "timeout";
    case "pending":
    default:
      return elapsedMs >= capMs ? "timeout" : "poll";
  }
};

/** succeeded + pay_order → 回付款頁繼續付款的目標路徑。 */
export const resolveRedirectPath = (returnContext: ReturnContext | null | undefined): string | null => {
  if (returnContext && returnContext.type === "pay_order") {
    return returnContext.return_path;
  }
  return null;
};
